var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sortable-item",on:{"click":_vm.doSort}},[_c('span',[_vm._v(" "+_vm._s(_vm.item.title))]),_c('sortable-caret',{attrs:{"sort":_vm.item.sort}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }